module.exports = __webpack_public_path__ + "static/img/色相／饱和度 564.7b514ffa.png";